import {Box, createStyles, MantineColor} from '@mantine/core';
import React, {ReactNode} from 'react';

interface HomepageBannerProps {
  children: ReactNode;
  color: MantineColor;
  leftSection?: ReactNode;
  rightSection?: ReactNode;
}

const useStyles = createStyles((theme, {color}: {color: MantineColor}) => ({
  banner: {
    backgroundColor: theme.colors[color][1],
    borderLeft: `4px solid ${theme.colors[color][7]}`,
    borderRadius: theme.radius.sm,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing.sm,
    margin: '0 auto',
    gap: theme.spacing.md,
  },
  flexGrow: {
    flexGrow: 1,
  },
}));

export default function HomepageBanner({
  children,
  color,
  leftSection,
  rightSection,
}: HomepageBannerProps): JSX.Element {
  const {classes} = useStyles({color});

  return (
    <Box className={classes.banner}>
      {leftSection}
      {children}
      {rightSection != null && (
        <>
          <div className={classes.flexGrow} />
          {rightSection}
        </>
      )}
    </Box>
  );
}
